<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Galerie vidéos " />
            <MediathequePosteVideo />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import MediathequePosteVideo from '../MediathequePoste/MediathequePosteVideo'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'MediathequePostePage',
    components: {
        NavBar,
        PageTitle,
        MediathequePosteVideo,
        FooterComp,
    }
}
</script>